import * as React from 'react';
import { styles } from './styles';
import { ColorTypes } from '@joykit/variables/colors';

export type AvatarSize = number | 'auto';

interface AvatarProps {
  backgroundColor: ColorTypes;
  size: AvatarSize;
  url: string | null | undefined;
}

class Avatar extends React.PureComponent<AvatarProps> {
  static defaultProps = {
    size: 50,
    backgroundColor: 'light'
  };

  render(): React.ReactNode {
    return <div className={styles.container(this.props.url, this.props.size, this.props.backgroundColor)} />;
  }
}

export { Avatar };
